import {theme} from "Theme";

import {useTransportMaterialTable} from "material/data";

import {PermitExtensionMaterialsEditableCells} from ".";
import {SimpleTable} from "base/table/components";

import Stack from "@mui/system/Stack";
import Typography from "@mui/material/Typography";

const PermitExtensionMaterialsTable = ({
    extension,
    displayFees = false,
    disabled = false,
}) => {
    const materials = extension?.material_set;
    const {tableColumns} = useTransportMaterialTable(displayFees);

    return (
        <SimpleTable
            dataRows={materials}
            tableColumns={[
                ...tableColumns,
                {
                    id: "extension_materials",
                    align: "center",
                    width: 25,
                    label: (
                        <Stack
                            alignItems="center"
                            sx={{
                                mb: -1,
                                mr: -0.24,
                                borderLeft: `3px solid ${theme.palette.primary.main}`,
                                backgroundColor: theme.palette.pageBackground.secondary,
                            }}
                        >
                            <Typography variant="subtitle2" pt={1}>
                                Prorrogação
                            </Typography>
                            <Stack direction="row" spacing={2}>
                                <Typography
                                    variant="caption"
                                    fontSize="11px"
                                    minWidth={40}
                                    textAlign="center"
                                >
                                    Transp.
                                </Typography>
                                <Typography
                                    variant="caption"
                                    fontSize="11px"
                                    minWidth={64}
                                    textAlign="center"
                                >
                                    Quant.
                                </Typography>
                            </Stack>
                        </Stack>
                    ),
                    formatFunction: material => {
                        return (
                            <PermitExtensionMaterialsEditableCells
                                material={material}
                                extension={extension}
                                disabled={disabled}
                            />
                        );
                    },
                },
            ]}
        />
    );
};

export default PermitExtensionMaterialsTable;
